class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartEditButton extends HTMLElement {
  constructor() {
    super();
    this.variant = this.querySelector('select');
    this.cart = document.querySelector('cart-drawer');

    this.quantity = this.dataset.productQty
    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this))
      }
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    // this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    cartItems.enableLoading(this.dataset.index)
    formData.append('form_type', 'product')
    formData.append('id', this.variant.value)
    formData.append('quantity', this.quantity)
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {

        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          // window.location = window.routes.cart_url;
          return;
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          cartItems.updateQuantity(parseInt(this.dataset.index) + 1, 0)
        }
      })
      .catch((e) => {

      })
      .finally(() => {
        // this.submitButton.classList.remove('loading');
        // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

customElements.define('cart-edit-button', CartEditButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInputVar) => total + parseInt(quantityInputVar.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.cart = document.querySelector('cart-drawer');
  }

  onChange(event) {
    if (event.target.name === 'variant') {
      return;
    }
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart__contents',
        section: document.getElementById('cart__contents').dataset.id,
        selector: '.cart__contents_wrapper',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ]

  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      }).catch((_err) => {

      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);


        this.getSectionsToRender().forEach((section => {

          if (document.getElementById(section.id)) {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }


        }));

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

        // if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        //   cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        // } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        //   // trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        // } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        //   // trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        // }
        if (this.cart) {
          this.cart.renderContents(parsedState);
        }
        this.disableLoading();

      }).catch((e) => {



        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();

      }).finally(() => {
        const changeButtonsMain = [...document.querySelectorAll('.main-ChangeOption'), ...document.querySelectorAll('.changeOption')]
        changeButtonsMain.forEach((button) => {
          button.addEventListener('click', (e) => {
            const parent = e.target.parentElement
            if (parent) {
              parent.querySelector('.product-options__wrapper').style.display = 'flex'
              e.target.style.display = "none"
            }
          })
        })
        const cancelButtonsMain = [...document.querySelectorAll('.main-cancelOption'), ...document.querySelectorAll('.cancelOption')]
        cancelButtonsMain.forEach((button) => {
          button.addEventListener('click', (e) => {
            const parent = e.target.parentElement.parentElement
            if (parent) {
              parent.querySelector('.product-options__wrapper').style.display = 'none'
              parent.querySelector('.main-ChangeOption').style.display = "inherit"
            }
          })
        })
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      if (lineItemError) {
        lineItemError
          .querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  }

  getSectionInnerHTML(html, selector) {



    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
